import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getReginationRequest = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/employee/resignation/listbyfilter${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createReginationRequest = (data, token) =>
  axios.post(`${baseUrl}/employee/resignation/request`, data, {
    headers: {
      authorization: token,
    },
  });

export const deleteReginationRequest = (id, token) =>
  axios.delete(`${baseUrl}/ReginationRequest/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updateReginationRequest = (data, token) =>
  axios.post(`${baseUrl}/employee/resignation/requestupdate`, data, {
    headers: {
      authorization: token,
    },
  });
export const updateReginationRequestNoticePeriod = (data, token) =>
  axios.patch(`${baseUrl}/employee/resignation/noticeperiodupdate`, data, {
    headers: {
      authorization: token,
    },
  });
export const getReginationRequestById = (id, token) => {
  return axios.get(`${baseUrl}/employee/resignationrequest/${id}`, {
    headers: {
      authorization: token,
    },
  });
};
export const getEmployeeResignationDetailById = (token) =>
  axios.get(`${baseUrl}/employee/resignation/EmployeeDetails`, {
    headers: {
      authorization: token,
    },
  });
///resignation status bar///

export const getResignationStatusById = (id, token) => {
  return axios.get(`${baseUrl}/employee/resignation/status/${id}`, {
    headers: {
      authorization: token,
    },
  });
};
//latest status
export const getLatestStatusDetailsById = (id, token) => {
  return axios.get(`${baseUrl}/employee/resignation/lateststatus/${id}`, {
    headers: {
      authorization: token,
    },
  });
};
